import React from "react";
import { ArrowDown } from "react-feather";
import Typing from "../../Layout/Typing/Typing";
import { getIcon, getLink } from "../../utils";
import notableAlumni from "../../utils/alumni";
import { vanGoghPainting } from "../../utils/images";
import "./alumni.scss";
import Alumnus from "./Alumnus";

const Alumni = () => {
	return (
		<main className="notable-alumni">
			<section
				className="notable-alumni-hero"
				style={{
					backgroundImage: `url(${vanGoghPainting})`,
				}}
			>
				<h1 className="notable-alumni-hero__heading">
					{window.innerWidth > 672 ? (
						<Typing>Notable Alumni</Typing>
					) : (
						"Notable Alumni"
					)}
				</h1>
				<div
					className="notable-alumni-hero-scroll"
					onClick={() => window.scrollTo(0, window.innerHeight)}
				>
					<span>Scroll to start the journey</span>
					<div className="notable-alumni-hero-scroll__scrolldown">
						<div className="notable-alumni-hero-scroll__chevrons">
							<div className="notable-alumni-hero-scroll__chevrondown"></div>
							<div className="notable-alumni-hero-scroll__chevrondown"></div>
						</div>
					</div>
				</div>
			</section>
			{notableAlumni.map((alumnus, index) => (
				<Alumnus {...alumnus} index={index} />
			))}
		</main>
	);
};

export default Alumni;
